var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBtnTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2613 11.6434C8.22789 9.74334 6.21093 7.85864 4.18614 5.97821C4.06241 5.86283 4.03229 5.80004 4.16704 5.65967C4.76002 5.04444 5.34448 4.41355 5.92097 3.78294C6.07467 3.61398 6.18584 3.59813 6.3592 3.76365C8.28144 5.56387 10.2075 7.35997 12.1335 9.15209C12.2943 9.30208 12.3419 9.40815 12.1687 9.58977C11.526 10.2666 10.8995 10.9508 10.2575 11.6475L10.2613 11.6434Z",
    fill: "#C7D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.07884 11.9189C3.05863 11.9545 2.0424 11.99 1.02219 12.0256C0.95358 10.0609 0.888817 8.0921 0.824193 6.12726C1.3153 6.02233 1.81127 6.05687 2.30544 6.03962C2.82352 6.02153 3.34377 5.95149 3.86491 6.02107C3.93365 7.98977 4.00625 9.95433 4.07898 11.9229L4.07884 11.9189Z",
    fill: "#C7D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.2587 3.39192C6.22391 2.39562 6.18925 1.4033 6.15048 0.407138C8.11519 0.338529 10.0799 0.26992 12.0486 0.201172C12.0834 1.19747 12.118 2.18979 12.1488 3.18623C10.1881 3.2547 8.22341 3.32331 6.26268 3.39178L6.2587 3.39192Z",
    fill: "#C7D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.77611 3.47906C2.75988 3.51455 1.74764 3.5499 0.731412 3.58539C0.69662 2.58908 0.661829 1.59278 0.627176 0.600464C1.6434 0.564976 2.65963 0.529489 3.67188 0.494141C3.70667 1.49044 3.74146 2.48674 3.77625 3.48305L3.77611 3.47906Z",
    fill: "#C7D0CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBtnTag);
export default __webpack_public_path__ + "static/media/heroBtnTag.a22112cc09870d75ae7900258657908a.svg";
export { ForwardRef as ReactComponent };